<!-- eslint-disable max-len -->
<template>
  <div class="h-screen flex bg-gray-100">
    <div class="hidden md:flex md:flex-shrink-0">
      <div class="flex flex-col w-64 shadow-2xl">
        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div
          class="flex flex-col flex-grow border-r border-gray-200 pt-5 pb-4 bg-white overflow-y-auto"
        >
          <div class="flex items-center justify-center flex-shrink-0 px-4">
            <img class="h-8 sidebar-logo" src="../assets/logo.png" alt="implicit" />
          </div>
          <div class="mt-5 flex-grow flex flex-col">
            <div class="grid">
              <div class="p-5 flex items-center space-x-3">
                <div class="flex-shrink-0">
                  <img class="h-10 w-10 rounded-full" :src="profilePic" alt="username" />
                </div>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-900 mb-0">
                    {{ acctUsername }}
                  </p>
                  <p class="text-sm text-gray-500 truncate mb-0">
                    {{ email }}
                  </p>
                </div>
              </div>
            </div>
            <nav class="flex-1 px-5 bg-white space-y-1">
              <router-link
                v-for="item in navigationlist"
                :key="item.name"
                :to="item.href"
                v-on:click.native="updateCurrent(item.href)"
                :class="[
                  item.current ? 'font-bold text-green-900' : 'text-blue-800',
                  'group flex items-center px-2 py-2 text-sm font-medium rounded-md font-bold hover:no-underline',
                ]"
              >
                <component
                  :is="item.icon"
                  :class="[
                    item.current ? 'text-green-900' : 'text-blue-800',
                    'mr-3 flex-shrink-0 h-6 w-6 icon',
                  ]"
                  aria-hidden="true"
                />
                {{ item.name }}
              </router-link>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col w-full flex-1 overflow-hidden">
      <div class="relative flex-shrink-0 flex h-16 bg-white">
        <div class="flex ml-5 items-center md:hidden">
            <!-- Mobile menu button-->
            <button
              type="button"
              class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded="false"
              @click.prevent="mobileMenu = !mobileMenu"
            >
              <span class="sr-only">Open main menu</span>
              <!--
                Icon when menu is closed.

                Heroicon name: outline/menu

                Menu open: "hidden", Menu closed: "block"
              -->
              <svg
                class="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        <div class="flex-1 px-16 flex justify-end">
          <div class="ml-4 flex items-center md:ml-6">
            <button
              class="bg-white p-1 rounded-full text-gray-600 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              v-on:click="signOut"
            >
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
      <div class="md:hidden" :class="mobileMenu ? 'block' : 'hidden'" id="mobile-menu">
        <div class="pt-2 space-y-1">
          <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
            <div
          class="flex flex-col flex-grow border-r border-gray-200 pt-5 pb-4 bg-white overflow-y-auto"
        >
          <div class="flex flex-shrink-0 px-6">
            <img class="h-8" src="../assets/logo.png" alt="implicit" />
          </div>
          <div class="mt-5 flex-grow flex flex-col">
            <div class="grid">
              <div class="p-5 flex items-center space-x-3">
                <div class="flex-shrink-0">
                  <img class="h-10 w-10 rounded-full" :src="profilePic" alt="username" />
                </div>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-900 mb-0">
                    {{ acctUsername }}
                  </p>
                  <p class="text-sm text-gray-500 truncate mb-0">
                    {{ email }}
                  </p>
                </div>
              </div>
            </div>
            <nav class="flex-1 px-5 bg-white space-y-1">
              <router-link
                v-for="item in navigationlist"
                :key="item.name"
                :to="item.href"
                v-on:click.native="updateCurrent(item.href), mobileMenu=!mobileMenu"
                :class="[
                  item.current ? 'font-bold text-green-900' : 'text-blue-800',
                  'group flex items-center px-2 py-2 text-sm font-medium rounded-md font-bold hover:no-underline',
                ]"
              >
                <component
                  :is="item.icon"
                  :class="[
                    item.current ? 'text-green-900' : 'text-blue-800',
                    'mr-3 flex-shrink-0 h-6 w-6 icon',
                  ]"
                  aria-hidden="true"
                />
                {{ item.name }}
              </router-link>
            </nav>
          </div>
        </div>
        </div>
      </div>
      <main class="flex-1 relative overflow-y-auto focus:outline-none">
        <div class="pt-6 pb-2">
          <div class="max-w-7xl mx-auto sm:px-0 md:px-8">
            <BreadCrumb :pages="navigationlist.filter((item) => item.current)" />
          </div>
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import configure from '@/components/icons/configure.vue';
import topics from '@/components/icons/topics.vue';
import sources from '@/components/icons/sources.vue';
import book from '@/components/icons/book.vue';
import creator from '@/components/icons/creator.vue';
import activity from '@/components/icons/activity.vue';
import BreadCrumb from '@/components/breadCrumb.vue';
import store from '@/store';
import firebase from '@/services/firebase';
import utils from '@/services/utils';
import userInfo from '@/services/userInfo';

const navigation = [
  {
    name: 'Configure',
    href: '/admin/configure',
    icon: configure,
    current: false,
  },
  {
    name: 'Products',
    href: '/admin/products',
    icon: book,
    current: false,
  },
  {
    name: 'User Activity',
    href: '/admin/user-activity',
    icon: activity,
    current: false,
  },
];
const adminnavigation = [
  {
    name: 'Configure',
    href: '/admin/configure',
    icon: configure,
    current: false,
  },
  {
    name: 'Feed Topics',
    href: '/admin/topics',
    icon: topics,
    current: false,
  },
  {
    name: 'Feed Source',
    href: '/admin/sources',
    icon: sources,
    current: false,
  },
  {
    name: 'Products',
    href: '/admin/products',
    icon: book,
    current: false,
  },
  {
    name: 'User Activity',
    href: '/admin/user-activity',
    icon: activity,
    current: false,
  },
  {
    name: 'Course Creators',
    href: '/admin/course-creators',
    icon: creator,
    current: false,
  },
];

const userNavigation = [
  { name: 'Your Profile', href: '#' },
  { name: 'Settings', href: '#' },
  { name: 'Sign out', href: '#' },
];

export default {
  name: 'admin',
  components: { BreadCrumb },
  store,
  data() {
    return {
      mobileMenu: false,
      statusMsg: null,
      signedIn: false,
      userInfo: null,
      navigationlist: [],
      acctUsername: store.state.user ? store.state.user.name : null,
      email: store.state.user ? store.state.user.email : null,
      profilePic: 'https://abs.twimg.com/sticky/default_profile_images/default_profile_normal.png',
      isAdmin: false,
      navigation,
      adminnavigation,
      userNavigation,
    };
  },
  async created() {
    this.userInfo = await userInfo.getUserInfo(store.state.user.uid);
    this.navigationlist = this.userInfo.user.role === 'SUPERADMIN' ? this.adminnavigation : this.navigation;
    this.profilePic = this.userInfo.user.profilePic ? this.userInfo.user.profilePic : this.profilePic;
    this.navigationlist.map((nav) => {
      if (nav.href === window.location.pathname) {
        /* eslint-disable no-param-reassign */
        nav.current = true;
      } else {
        /* eslint-disable no-param-reassign */
        nav.current = false;
      }
      return nav;
    });
  },
  methods: {
    async updateCurrent(href) {
      this.navigationlist.forEach((nav) => {
        if (nav.href === href) {
          nav.current = true;
        } else {
          nav.current = false;
        }
      });
    },
    async signOut() {
      try {
        await firebase.logout(this);
        store.commit('setLogout');
        this.$router.push({ path: '/' });
      } catch (e) {
        utils.log('error signing out: ', e);
      }
    },
  },
};
</script>
